import { AppBar, Box, Button, Toolbar } from '@mui/material';
import { Link as RouterLink, Outlet } from 'react-router';
import { BrandLogo } from '@/components/brand/BrandLogo';
import { ColorModeToggle } from '@/components/ColorModeToggle';
import { LandingFooter } from './LandingFooter';

/** Frame of the brand site's inner pages (guides). */
export function LandingShell() {
  return (
    <Box sx={{ minHeight: '100dvh', display: 'flex', flexDirection: 'column' }}>
      <AppBar position="sticky">
        <Toolbar sx={{ gap: 1, minHeight: { xs: 60, sm: 68 } }}>
          <Box
            component={RouterLink}
            to="/"
            sx={{ mr: 'auto', minWidth: 0, color: 'inherit', textDecoration: 'none' }}
          >
            <BrandLogo size="small" />
          </Box>
          <Button color="inherit" component={RouterLink} to="/guias">
            Guias
          </Button>
          <ColorModeToggle />
          <Button variant="contained" href="/#quero-conhecer" sx={{ whiteSpace: 'nowrap' }}>
            Quero conhecer
          </Button>
        </Toolbar>
      </AppBar>
      <Box component="main" sx={{ flex: 1 }}>
        <Outlet />
      </Box>
      <LandingFooter />
    </Box>
  );
}
